import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WhatsappMsgToExpiredChatPage } from './whatsapp-msg-to-expired-chat.page';

const routes: Routes = [
  {
    path: '',
    component: WhatsappMsgToExpiredChatPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WhatsappMsgToExpiredChatPageRoutingModule {}
